import appContent from '@/services/content/appContent.typed';
import {twx} from '@/utils/tailwindUtils';

export type AutoDeliveryDcxStatusBadgeStatus = 'active' | 'onHold';

type AutoDeliveryDcxStatusBadgeProps = {
    className?: string;
    status: AutoDeliveryDcxStatusBadgeStatus;
};

const AutoDeliveryDcxStatusBadge = ({className, status}: AutoDeliveryDcxStatusBadgeProps) => {
    const {deliveryActiveStatusLabel, deliveryOnHoldStatusLabel} = appContent.getAutoDeliveryContent() || {};
    const label = {
        active: deliveryActiveStatusLabel,
        onHold: deliveryOnHoldStatusLabel,
    }[status];

    if (!label) return null;

    return (
        <div
            className={twx(
                'inline-flex max-w-fit items-center gap-2 rounded px-2 py-1',
                {
                    active: 'bg-signal-success-bg',
                    onHold: 'bg-signal-warning',
                }[status],
                className
            )}
        >
            <span className='h-2 w-2 shrink-0 rounded-full bg-romance opacity-80' aria-hidden='true' />
            <span className='text-14 leading-[20px] text-romance'>{label}</span>
        </div>
    );
};

export default AutoDeliveryDcxStatusBadge;
